import {define, inject} from '@injex/core';
import {computed, makeObservable, observable} from 'mobx';
import IDashboard from '../../interfaces/IDashboard';
import {ColumnsManager} from '@vidazoo/ui-kit';
import ApiManager from '../../../../common/api/ApiManager.mdl';
import {DataListQuery} from '../../../../common/models/DataListQuery';
import CloudManager from '../../../../common/managers/CloudManager.mdl';
import ChartsManager from '../../../../common/managers/ChartsManager.mdl';
import {DashboardsTableColumns} from '../common/constants';

@define()
export class DashboardsListModel extends ColumnsManager<IDashboard> {

    @inject() private apiManager: ApiManager;
    @inject() public cloudManager: CloudManager;
    @inject() public chartsManager: ChartsManager;

    @computed public get chartsById() {
        return Object.fromEntries((this.chartsManager.navigationItems.data || []).map(chart => [chart._id, chart]));
    }

    @observable public isDashboardsListOpen = false;

    public items: DataListQuery<IDashboard, []>;

    constructor() {
        super({
            persistKey: 'dashboards_list_columns',
        });

        this.setColumns(DashboardsTableColumns);

        this.items = new DataListQuery(this._fetchItems.bind(this), {defaultValue: [], dataObservType: observable.ref});

        makeObservable(this);

    }

    @computed public get data(): IDashboard[] {
        return this.items.data || [];
    }

    public get isLoading(): boolean {
        return this.items.isLoading;
    }

    private async _fetchItems() {
        const requestFields = {};
        DashboardsTableColumns.forEach((column) => {
            requestFields[column.key] = 1;
        });
        const response = await this.apiManager.dashboards.getAll({fields: {...requestFields, layouts: 1, updated: 1}, sort: {updated: -1}});
        return response.results;
    }

    public fetch() {
        return this.items.forceFetch();
    }
}
